/* kdc-cite.js — shared behaviour for the kdc-citation section:
   1. Rotating statistics (fade between up to 5 sourced stats).
   2. Testimonial quote rotation + click-to-video (kdcTqGo). */
(function () {
  if (window.__kdcCiteInit) return;
  window.__kdcCiteInit = true;

  window.kdcTqGo = function (el) {
    var idx = parseInt(el.getAttribute('data-video'), 10) || 1;
    var vrc = document.querySelector('.vrc');
    if (!vrc) return false;
    var y = vrc.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
    var slides = vrc.querySelectorAll('.vrc__slide');
    var slide = slides[idx - 1];
    if (slide) {
      var vp = vrc.querySelector('[data-vrc-viewport]');
      if (vp) {
        var vr = vp.getBoundingClientRect(), sr = slide.getBoundingClientRect();
        var delta = (sr.left + sr.width / 2) - (vr.left + vr.width / 2);
        vp.scrollTo({ left: vp.scrollLeft + delta, behavior: 'smooth' });
      }
      setTimeout(function () {
        var b = slide.querySelector('[data-play-btn]');
        if (b) b.click();
      }, 850);
    }
    return false;
  };

  function initStatRotators() {
    document.querySelectorAll('[data-kdc-stat-rotate]').forEach(function (wrap) {
      var statEl = wrap.querySelector('.kdc-cite__stat');
      var srcEl = wrap.querySelector('.kdc-cite__source');
      if (!statEl) return;
      var list;
      try { list = JSON.parse(wrap.getAttribute('data-kdc-stat-rotate')); } catch (e) { return; }
      if (!list || list.length < 2) return;
      var ms = parseInt(wrap.getAttribute('data-stat-rotate-ms'), 10) || 7000;
      var i = 0;
      setInterval(function () {
        wrap.style.opacity = '0';
        setTimeout(function () {
          i = (i + 1) % list.length;
          statEl.textContent = '« ' + list[i].t + ' »';
          if (srcEl) {
            srcEl.textContent = list[i].s || '';
            srcEl.style.display = list[i].s ? '' : 'none';
          }
          wrap.style.opacity = '';
        }, 520);
      }, ms);
    });
  }

  function initTqRotators() {
    var items = document.querySelectorAll('.kdc-cite-tq__item[data-rotate]');
    items.forEach(function (el) {
      var quoteEl = el.querySelector('.kdc-cite-tq__quote');
      if (!quoteEl) return;
      var list;
      try { list = JSON.parse(el.getAttribute('data-rotate')); } catch (e) { return; }
      if (!list || list.length < 2) return;
      var ms = parseInt(el.getAttribute('data-rotate-ms'), 10) || 5000;
      var i = 0;
      setInterval(function () {
        el.style.opacity = '0';
        setTimeout(function () {
          i = (i + 1) % list.length;
          quoteEl.textContent = '« ' + list[i].q + ' »';
          el.setAttribute('data-video', list[i].v);
          el.style.opacity = '';
        }, 520);
      }, ms);
    });
  }

  function initAll() { initStatRotators(); initTqRotators(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
